const axios = require("axios");

const urls = {
	estimateApiUrl: "https://estimate-api.floorberg.ru/api/v1/",
	homeUrl: "",
};

if (typeof window !== 'undefined') {
	urls.estimateApiUrl = window.estimateApiUrl;
	urls.homeUrl = window.homeUrl;
} else if (typeof process !== 'undefined') {
	urls.estimateApiUrl = process.env.ESTIMATE_API_URL;
	urls.homeUrl = process.env.MAIN_URL;	
}

const axiosApi = axios.create({
	baseURL: urls.estimateApiUrl,
	headers: {
		'Main-Url': urls.homeUrl
	}
});

axiosApi.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

module.exports = axiosApi;